// src/api/school.js
import request from '@/utils/request'

// api接口列表
const api = {
	sendCode: 'code/send',
	phoneLogin: 'phone/login',
	getCode: 'wechat/qrcode',
	getQrResult: 'wechat/check/status',
	qrLogin: 'wechat/login/callback',
	phoneBand: 'wechat/bind/phone',
	about: 'about/us',
	agreement: 'agreement',
	privacy: 'privacy',
	favorite: 'user/favorite',
	favoriteList: 'user/favorite/list',

	cardType: 'card/type',
	cardList: 'card/type/list',
	cardActive: 'card/activate',
	cardOrder: 'card/order',
	cardPay: 'card/pay',
	payStatus: 'card/query_order',
	feedback: 'feedback'
}

// 获取短信验证码
export function sendCode(data) {
	return request({
		url: api.sendCode,
		method: 'post',
		data
	})
}

// 手机号+验证码登录
export function phoneLogin(data) {
	return request({
		url: api.phoneLogin,
		method: 'post',
		data
	})
}
// 获取登录二维码
export function getCode(params) {
	return request({
		url: api.getCode,
		method: 'get',
		params
	})
}

export function getQrResult(data) {
	return request({
		url: api.getQrResult,
		method: 'post',
		data
	})
}

// 扫码code获取token等
export function qrLogin(data) {
	return request({
		url: api.qrLogin,
		method: 'post',
		data
	})
}

// 绑定手机号
export function phoneBand(data) {
	return request({
		url: api.phoneBand,
		method: 'post',
		data
	})
}

// 关于
export function about(params) {
	return request({
		url: api.about,
		method: 'get',
		params
	})
}

// 协议
export function agreement(params) {
	return request({
		url: api.agreement,
		method: 'get',
		params
	})
}

export function privacy(params) {
	return request({
		url: api.privacy,
		method: 'get',
		params
	})
}

// 收藏、取消收藏大学或专业
export function favorite(data) {
	return request({
		url: api.favorite,
		method: 'post',
		data
	})
}

// 收藏列表
export function favoriteList(params) {
	return request({
		url: api.favoriteList,
		method: 'get',
		params
	})
}

// 卡类型
export function cardType(params) {
	return request({
		url: api.cardType,
		method: 'get',
		params
	})
}

// 卡列表
export function cardList(params) {
	return request({
		url: api.cardList,
		method: 'get',
		params
	})
}

// 激活卡
export function cardActive(data) {
	return request({
		url: api.cardActive,
		method: 'post',
		data
	})
}

// 卡列表
export function cardOrder(params) {
	return request({
		url: api.cardOrder,
		method: 'get',
		params
	})
}

// 购买会员卡
export function cardPay(data) {
	return request({
		url: api.cardPay,
		method: 'post',
		data
	})
}

// 支付状态
export function payStatus(params) {
	return request({
		url: api.payStatus,
		method: 'get',
		params
	})
}
export function feedback(data) {
	return request({
		url: api.feedback,
		method: 'post',
		data
	})
}